import { SelectOptionType } from '@octano/global-ui';

import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { baseToSelectOption } from '../../../academicOffers/courses/utils';
import {
  ActivityType,
  CeSubject,
  Course,
  getFormDataRequest,
  getCourseFormDataRequest,
  getProgramFormDataRequest,
} from '../api';

interface FormDataActionReturn {
  schools: SelectOptionType[];
  campuses: SelectOptionType[];
  modalities: SelectOptionType[];
}

interface CourseFormDataActionReturn {
  courses: Course[];
  activityTypes: ActivityType[];
}

interface ProgramFormDataActionReturn {
  schools: SelectOptionType[];
  modalities: SelectOptionType[];
  activityTypes: ActivityType[];
  subjects: CeSubject[];
}

const getFormDataAction = actionKitImpFunction(
  async (): Promise<FormDataActionReturn> => {
    const response = await getFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    const { data } = response;

    return {
      schools: baseToSelectOption(data?.schools),
      campuses: baseToSelectOption(data?.campuses),
      modalities: baseToSelectOption(data?.modalities),
    };
  },
);

const getCourseFormDataAction = actionKitImpFunction(
  async (): Promise<CourseFormDataActionReturn> => {
    const response = await getCourseFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching course form data');
    }

    const { data } = response;

    return {
      courses: data?.courses || [],
      activityTypes: data?.activityTypes || [],
    };
  },
);

const getProgramFormDataAction = actionKitImpFunction(
  async (): Promise<ProgramFormDataActionReturn> => {
    const response = await getProgramFormDataRequest();
    if (response.error) {
      throw new Error('Error fetching program form data');
    }

    const { data } = response;

    return {
      schools: baseToSelectOption(data?.schools),
      modalities: baseToSelectOption(data?.modalities),
      activityTypes: data?.activityTypes || [],
      subjects: data?.subjects || [],
    };
  },
);

export { getFormDataAction, getCourseFormDataAction, getProgramFormDataAction };
export type {
  FormDataActionReturn,
  CourseFormDataActionReturn,
  ProgramFormDataActionReturn,
};
